// Selectors
import { getElement } from '../../../selectors/elementSelector';

// Types
import type { GenericReduxDispatch } from '../../../../../common/actions/actionTypes';
import type { ImMNElement } from '../../../../../common/elements/elementModelTypes';
import type { ReduxState } from '../../../../types/reduxTypes';

/**
 * Reads the element's current record straight from the store.
 *
 * Save and staging flows run synchronously after dispatching element changes — before React re-renders —
 * so hook props there can be a render behind. Deriving variant URLs or persisted sources from the prop in
 * that window has caused real bugs (a first background removal stuck on its toast, a stale save hand-off
 * source); anything reacting to a just-dispatched change must read the store instead.
 */
export const readCurrentElementFromStore = (
    dispatch: GenericReduxDispatch,
    elementId: string,
    fallbackElement: ImMNElement,
): ImMNElement =>
    dispatch((_: GenericReduxDispatch, getState: () => ReduxState) => getElement(getState(), { elementId })) ||
    fallbackElement;
